import { render, staticRenderFns } from "./wdmr.vue?vue&type=template&id=18737d50"
import script from "./wdmr.vue?vue&type=script&lang=js"
export * from "./wdmr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports